var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import state from './State';
import router from './router/index';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.model = { username: '', password: '' };
        this.error = { message: '' };
    }
    clearForm() {
        this.error.message = '';
        this.model = { username: '', password: '' };
    }
    onSubmit() {
        const loginUrl = state.get('request.url.login');
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const params = state.get('request.params.login');
        const enc = encodeURIComponent;
        const body = [
            `${enc('username')}=${enc(this.model.username)}`,
            `${enc('password')}=${enc(this.model.password)}`,
        ].join('&');
        void fetch(loginUrl, Object.assign(Object.assign({}, params), { body }))
            .then((res) => res.json())
            .then((data) => {
            if (data.user) {
                state.update('user', data.user);
                void router.push('/licenses');
            }
            else {
                this.error.message = 'Wrong password';
            }
        });
    }
};
Login = __decorate([
    Component({
        name: 'Login',
    })
], Login);
export default Login;
